/*
 * Money formatting shared by every ToneWoodAmp script.
 *
 * Liquid's `| money` filter respects the shop's currency and format; JavaScript
 * has no equivalent, so any hardcoded "$" produces the wrong symbol the moment
 * a price is re-rendered client side. This mirrors the filter using the shop's
 * own money_format string, so server- and client-rendered prices agree.
 *
 * Values are integer cents throughout, matching Shopify's own convention.
 */

(function () {
  /*
   * Always formats the magnitude. The sign is applied by the caller to the
   * whole formatted string, so a negative reads "-£25.00" rather than
   * "£-25.00" — the minus belongs outside the currency symbol.
   */
  function digits(cents, decimals, thousands, decimal) {
    const amount = Math.abs(Number(cents) || 0) / 100;
    const fixed = amount.toFixed(decimals);
    const [whole, fraction] = fixed.split('.');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return fraction ? grouped + decimal + fraction : grouped;
  }

  /*
   * Shopify money_format placeholders. Anything unrecognised falls back to the
   * two-decimal comma-grouped form rather than rendering an empty string.
   */
  const TOKENS = {
    amount: (c) => digits(c, 2, ',', '.'),
    amount_no_decimals: (c) => digits(c, 0, ',', ''),
    amount_with_comma_separator: (c) => digits(c, 2, '.', ','),
    amount_no_decimals_with_comma_separator: (c) => digits(c, 0, '.', ''),
    amount_with_apostrophe_separator: (c) => digits(c, 2, "'", '.'),
    amount_with_space_separator: (c) => digits(c, 2, ' ', ','),
    amount_no_decimals_with_space_separator: (c) => digits(c, 0, ' ', ''),
  };

  window.twaMoney = function twaMoney(cents, format) {
    const pattern = format || window.twaMoneyFormat || '${{amount}}';
    const value = Number(cents) || 0;
    const body = String(pattern).replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, token) {
      const fn = TOKENS[token] || TOKENS.amount;
      return fn(value);
    });
    return value < 0 ? `-${body}` : body;
  };
})();
